import script from "./AppLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLoading.vue?vue&type=script&lang=ts&setup=true"

import "./AppLoading.vue?vue&type=style&index=0&id=50645f03&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50645f03"]])

export default __exports__